import {
  useEffect,
  React,
  useState,
  icons,
  useSelector,
  faqListApi,
  setFaqData,
  useDispatch,
  startFaqLoading,
  stopFaqLoading,
  Components
} from '../utils/npm'
import Loader from './Loader'

// const {Loader} = Components

const Accordian = () => {
  
  const faqItems = [
    {
      question: 'What is the life cycle of an IPO?',
      answer:
        "DreamSeat Enterprise Xperience Partners shall issue a full refund to any member who wishes to cancel their enrolment within 45 days prior to the start of the season. Stadium seat memberships are not refundable after the first home event of the football season. If a patron's seat is damaged or removed, DreamSeat EXP shall replace the item at no cost to the customer. Please contact the customer service hotline (864-626-9676) with any questions regarding the return policy. All sales are final. Refunds and adjustments will be considered on an individual basis."
    },
    {
      question: 'Is it mandatory to have a PAN number to apply in an IPO?',
      answer:
        'If you are unable to log in, please make sure you have created a new account first. This ordering portal is different than the one where you purchase your Texas A&M game tickets.'
    },
    {
      question: 'How many days will an IPO remain open for the public?',
      answer:
        "DreamSeat Enterprise Xperience Partners shall issue a full refund to any member who wishes to cancel their enrolment within 45 days prior to the start of the season. Stadium seat memberships are not refundable after the first home event of the football season. If a patron's seat is damaged or removed, DreamSeat EXP shall replace the item at no cost to the customer. Please contact the customer service hotline (864-626-9676) with any questions regarding the return policy. All sales are final. Refunds and adjustments will be considered on an individual basis."
    },
    {
      question:
        'Can I apply for an IPO through multiple applications on the same name?',
      answer:
        'If you are unable to log in, please make sure you have created a new account first. This ordering portal is different than the one where you purchase your Texas A&M game tickets.'
    },
    {
      question: 'How is the cut-off price of IPO decided?',
      answer:
        "DreamSeat Enterprise Xperience Partners shall issue a full refund to any member who wishes to cancel their enrolment within 45 days prior to the start of the season. Stadium seat memberships are not refundable after the first home event of the football season. If a patron's seat is damaged or removed, DreamSeat EXP shall replace the item at no cost to the customer. Please contact the customer service hotline (864-626-9676) with any questions regarding the return policy. All sales are final. Refunds and adjustments will be considered on an individual basis."
    },
    {
      question: 'Can you sell the stocks before the IPO gets listed?',
      answer:
        'If you are unable to log in, please make sure you have created a new account first. This ordering portal is different than the one where you purchase your Texas A&M game tickets.'
    }
  ]

  const dispatch = useDispatch()
  const [selectedIndex, setSelectedIndex] = useState(null)
  const { faqData, error, loading } = useSelector(state => state.fagListData)
  const toggleSelected = index => {
    setSelectedIndex(selectedIndex === index ? null : index)
  }

  const getFaqList = async () => {
    dispatch(startFaqLoading())
    try {
      const response = await faqListApi()
      if (response.meta.status_code === 200) {
        dispatch(setFaqData(response?.data?.results))
      }
    } catch (error) {
    }
    dispatch(stopFaqLoading())
  }

  useEffect(() => {
    if (faqData.length === 0) {
      getFaqList()
    }
  }, [])

  return loading ? (
 <div className="flex justify-center pt-1 pb-2 custom-min-height"><Loader /></div>
  ) : (
    <ul className='shadow-box'>
      {faqData.map((item, index) => (
        <li
          key={index}
          className='relative border-b border-gray-200 accordian_item'
        >
          <button
            type='button'
            className='w-full py-4 text-left'
            onClick={() => toggleSelected(index)}
          >
            <div className='flex items-center justify-between'>
              <span className='accrodian_title'>{item.question}</span>
              <span className='plusMinus'></span>
              {selectedIndex === index ? (
                <div className='icon minus  cursor-pointer hover:scale-105 transition-all'></div>
              ) : (
                <div className='icon plus  cursor-pointer hover:scale-105 transition-all'></div>
              )}
            </div>
          </button>
          <div
            className={`relative ${
              selectedIndex === index ? 'overflow-auto' : 'overflow-hidden'
            } transition-all duration-500 ${
              selectedIndex === index ? 'border-t border-slate-200 pt-5' : ''
            } `}
            style={{
              maxHeight: selectedIndex === index ? '1000px' : '0'
            }}
          >
            <div className='px-6 pb-6'>
              <p className='text-sm lg:text-md'>{item.answer}</p>
            </div>
          </div>
        </li>
      ))}
    </ul>
  )
  
}

export default Accordian